/* eslint-disable */
import { Pencil } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
} from '@durma-soft/gros-sdk';

import { Link } from '@/components/shared/link';
import { Badge } from '@/components/shared/shadcn-ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/shared/shadcn-ui/tooltip';

import { TType } from '@/types/general';

export const columns = (t: TType): ColumnDef<any>[] => [
  {
    accessorKey: 'name',
    enableSorting: false,
    header: t('common.name'),
  },
  {
    accessorKey: 'restaurant_locations_count',
    enableSorting: false,
    header: t('track-location.count'),
    cell: (cellData) => {
      return (
        <Badge className="bg-muted border-gray-300 text-gray-700 hover:bg-muted transition-all duration-300">
          {cellData.row.original.company_locations_count}
        </Badge>
      );
    },
  },
  {
    id: 'actions',
    enableHiding: false,
    cell: (cellData) => {
      const restaurant = useAuthUserRestaurant();
      const hasEditPermission =
        restaurant.role !== RESTAURANT_USER_ROLE.EMPLOYEE &&
        restaurant.role !== RESTAURANT_USER_ROLE.TRACK_EMPLOYEE;
      return (
        <TooltipProvider delayDuration={100}>
          <div className="flex items-center justify-center gap-4">
            {/* Edit restaurant track location */}
            {hasEditPermission && (
              <Tooltip>
                <TooltipTrigger>
                  <Link
                    replace
                    to={`/restaurant/track-locations/edit/${cellData.row.original.id}`}
                    className="flex items-center justify-center text-gray-700 "
                  >
                    <Pencil className="w-5 h-5" />
                  </Link>
                  <TooltipContent>
                    {t('track-location.edit-details')}
                  </TooltipContent>
                </TooltipTrigger>
              </Tooltip>
            )}
          </div>
        </TooltipProvider>
      );
    },
  },
];
